import Vue from 'vue';
import dateFormat from './date-format';
import formatThousand from './formatThousand';
import { round } from './number';
Vue.filter('date-format', dateFormat);
Vue.filter('round', round);
Vue.filter('formatThousand', formatThousand);
